// extracted by mini-css-extract-plugin
module.exports =  {"root":"a10a3f92e9--root--FdV6V","no-gap":"a10a3f92e9--no-gap--kC9rc","reviews":"a10a3f92e9--reviews--Rhp_Q"};